export default __webpack_public_path__ + "media/images/svg/social-linkedin.svg";